<template>
  <v-app class="whole">
    <div class="inside">
      <v-img src="./books.jpg" :height="300" ></v-img>
      <div class="btnSpace_back display_desktop">
        <v-btn color="primary" x-large text @click="goback"><span class="material-icons">
          chevron_left</span>もどる</v-btn>
      </div>
    <div class="myform">
      
      <div class="title-spaced">
      </div>

      <div class="titleCompany">個人情報保護方針</div>
      <div class="memoText">
        株式会社K-51インターナショナル（以下、当社）では、個人情報保護に関する法令を尊守するとともに、本プライバシーポリシーを定め、社員一同適切な取り扱いを心がけます。
        株式会社K-51インターナショナル（以下、「当社」といいます）では、お客様のプライバシーの保護が非常に重要であると考えています。
        当社は、当社の「個人情報保護方針」に基づき、お客様の個人情報およびプライバシーにかかる事項（以下、「個人情報等」といいます）を安全に保護し、その利用目的を明確にし、正確な情報を確保することに努めています。
        本個人情報保護ポリシーは、当社がお客様の個人情報等を取り扱う際のポリシーについてご説明したものです。
        本個人情報保護ポリシーの対象となるのは当社が収集する情報に限ります。
        但し、個別にポリシーが示されている場合は当該ポリシーが優先されます。
        当社のウェブサイト上のリンク等で他社に提供された情報の利用については、当社の責任の対象外となります。
        お客様ご自身にて当該サイトの内容をよくご確認の上で、閲覧およびご利用をお願いいたします。
        尚、お客様が個人情報の提供をご希望されない場合は、お客様ご自身のご判断により、個人情報の提供を拒否することができます。
        この場合、当社におけるサービスをご利用になれない場合がありますので、予めご了承ください。
      </div>

      <div class="titleCompany">個人情報等の収集について</div>
      <div class="memoText">
        お客様の個人情報等をいただく際には、その使用目的、使用方法等を、あらかじめお客様に告知し、適切な範囲内で収集します。使用目的は、原則として以下の場合に限定します。
        ・当社の商品・サービスの企画、開発および販売のため
        ・当社の商品・サービス等に関する情報をお知らせするため
        ・展示会、セミナー、トレーニング、懸賞、コンテスト、その他イベントの運営のため
        ・お問合せやご要望、アンケート等へ回答・対応するため
        ・本サイトの使用状況の分析、コンテンツ・レイアウト・サービスの向上のための判断材料として利用するため
        ・年賀状、季節のご挨拶等、当社のマーケティング活動支援のため
        ＜クッキー（Cookie）の利用＞当社は、前記の利用目的のために、クッキー（Cookie）を利用して情報を収集させていただくことがあります。
        クッキー（Cookie）とは、ウェブ・サーバから送信されてコンピュータのハードディスクドライブにインターネットブラウザにより保存される少量のデータです。
        クッキー（Cookie）自体には、お客様ご自身やEメールアドレスに関する情報は含まれませんが、お客様が個人情報等を当社に提供されると、お客様が当社のウェブサイトにアクセスされる際にお客様が使用されるパソコン等の通信端末が特定されます。
        但し、クッキー（Cookie）を利用して、お客様のハードディスクドライブのデータや、Eメールアドレス、利用者個人の識別情報を入手することはできません。
        お客様はクッキー（Cookie）を受け取ったときに通知されるように、またクッキー（Cookie）が送信されないようにブラウザを設定することができます。
      </div>

      <div class="titleCompany">個人情報等の利用について</div>
      <div class="memoText">
        当社は、お客様の個人情報等を、法的義務等の正当な理由のある場合を除いて、お客様に明示した収集目的以外では利用しません。
        ただし、お客様個人を特定せずに、お客様数、売上げ、ウェブサイトの閲覧方法等の統計データを収集するために利用する場合があります。
      </div>

      <div class="titleCompany">個人情報等の第三者への提供について</div>
      <div class="memoText">
        当社は、お客様の個人情報等を、特段の事情がない限り、お客様の同意なくしては、第三者に提供しません。 ただし、以下の利用に関しては、お客様情報を第三者に提供させていただくことがございます。
        <br>● 社外への業務委託のための利用お客様に明示した利用目的を達成するために業務を外部業者等へ委託する場合、当社の厳正な管理下のもと、業務を行うのに必要最小限の範囲で、お客様情報の預託、提供等させていただくことがございます。
        <br>● 法令等に基づく利用当社は、法的根拠、公衆の利益により、裁判所、行政機関、監督官庁その他の公的機関から第三者に情報を提供するよう強制された場合、提供を拒否する合理的な理由がなく、お客様から同意をいただくことが難しい場合には、お客様情報を開示させていただくことがございます。
      </div>
      <div class="titleCompany">個人情報等の管理について</div>
      <div class="memoText">
        当社は、個人情報等を各利用目的に応じて適切に管理いたします。このために、個人情報等の管理責任者の設置、個人情報等への不当なアクセス、紛失、改竄、漏洩等に対するセキュリティ対策等を実施します。
      </div>

      <div class="titleCompany">個人情報等の訂正・削除について</div>
      <div class="memoText">
        当社が管理するお客様ご自身の個人情報等に誤りがあり、お客様から当社に訂正または削除のお申し出があった場合、当社は、お客様の個人情報の漏洩防止等を目的として、お客様本人であることの確認をお願いした上で、適切に対応いたします。
      </div>

    </div>
    </div>
  </v-app>
</template>

<script>
import products from "./ECサイト商品リスト.json";
import { mapGetters } from "vuex"
  export default {
    data() {
      return {
        inputForm: {},      
        checkboxdata: [],
        item: '上記の内容と同じ',
        val: true,
        items: [],
        products,
      }
    },
    computed:{
      product() {
        const result = products.find((v) => v.id === Number(this.id))
        return result
      },
      ...mapGetters('cart', ['productsList','profile']),

    },
    mounted() {
     
    },
    filters: {

    },
    methods: {
      buy() {
        // this.$store.dispatch('cart/updateProfile', inputForm )
        // this.$router.push({ name: 'co-info' })
      },
      goback() {
        this.$router.go(-1)
      },
    },
  }
</script>
<style scoped>
  .whole {
      background-color: rgba(218, 218, 219, 0.2);
      color:#555555;
    }
    .inside {
      margin: 10%;
      padding: 0 0 0% 0;
      background-color: white;
      height: 100%;
    }
    @media screen and (min-width:896px){
        .inside {
          margin: 1% 10%;
        }
      }
  .myform{
   background-color: white;
    width: 80%;
    margin: 3% auto;
  }
  @media screen and (max-width:480px){
  /*画面幅が480pxまでの時*/
    .myform{
      width: 100%;
    }
  }
  /* @media screen and (min-width:781px){ */
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .myform{
      width: 70%;
    }
  }
  
  .mtb-medium{
    margin: 5% 0%;
  }
  .mb{
    margin-bottom: 3%
  }
  .b-form-group {
    margin: 15% 0%;
    padding: 15% 0%;
  }
  .btnSpace{
    width: 50%;
    margin: 10% auto;
  }
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .btnSpace{
      width: 30%;
      margin: 15% auto;
    }
  }
  .form-spaced{
    padding: 0% 0;
  }
  .title-spaced{
    padding: 0% 0;
  }
  .alert-spaced{
    padding: 3% 0 0 0;
    /* margin: 5% 0; */
  }
  .question_spaced{
    padding: 7% 0;
  }
  .question_inside_spaced{
    padding: 4% 0;
  }
  .spinbtn-spaced{
    padding: 0 5%;
  }
  .v-btn{
    text-decoration: none;
  }
  .stepper-text {
    color:#555555;
    font-size: 0.8rem;
  }
  .stepper-text-option {
    color:white;
    font-size: 0.6rem;
    padding: 7% 0;
  }
  .tableSpace {
    margin: 1% 0 7% 0;
  }
  .spinbtn-spaced{
    width: 60%;
    padding: 0 0% 0 0 ;
  }
  .inputForm_spaced {
    margin: 5% 10% 5% 0;
    text-align: left;
    color:#555555;
  }
  .formSpace2 {
    margin: 3% 0 0 0;
  }
  .titleCompany {
    font-size: 1.5rem;
    border-left: solid 7px #3c45bd;
    padding: 0 0  0 3% ;
  }
  .btnSet2 {
    margin: 15% 0;
    text-align: center;
    padding: 0 30%;
  }
  .btnText {
    margin: 0 0 0 10%;
  }
  .formNum {
    padding: 0 5% 0 0 ;
  }
  .tableSpace_sum {
    margin: 0 0 0 60%;
  }
  .infoSpace {
    margin: 7% 0;
  }
  .totalPrice {
    font-size: 1.6rem;
    font-weight: 500;
  }
  .memoText {
    margin: 2% 5% 5% 5% ;
  }
</style>